/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business aC Men's Hub frontend runtime config (API base URL + react-query defaults).
 * @graph-connects none
 */

type AcMensHubImportMetaEnv = ImportMetaEnv & {
  readonly VITE_API_URL?: string;
};

/** @graph-connects none */
const env = import.meta.env as AcMensHubImportMetaEnv;

/** @graph-connects none */
export const config = {
  apiUrl: env.VITE_API_URL ?? '/api',
  query: {
    staleTime: 60_000,
    gcTime: 5 * 60_000,
    retry: 1,
    refetchOnWindowFocus: false,
  },
} as const;
